var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 37.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 20,
    cy: 21.86,
    rx: 19,
    ry: 14.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.03,11.13S1.56,3.83,7.39,1.44s8.15,6.1,8.15,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.05,11.4s4.53-7.61-1.55-9.99-8.37,6.43-8.37,6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.96,18.94c-.46-2.26-2.2-3.8-3.97-3.83-2.17-.03-3.66,2.23-3.97,3.83-.7,3.65,3,8.93,7.94,8.93s8.74-5.3,7.94-8.93c-.35-1.58-1.8-3.86-3.97-3.83-1.76.03-3.51,1.57-3.97,3.83Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.d03621475acddd08dbc4cda835789047.svg";
export { ForwardRef as ReactComponent };